export default "__VITE_ASSET__Dg0ei8nZ__"